import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Item } from '../configurator/configuration';

@Component({
  selector: 'app-option',
  standalone: false,
  templateUrl: './option.component.html',
  styleUrl: './option.component.css'
})
export class OptionComponent {

    @Input({ required: true }) option: Item|null = null;
    @Output() changeOption = new EventEmitter<Item>();
    @Output() changeQuantity = new EventEmitter<Item>();
    
    
    changeState(): void {
        if ( this.option ) {
            this.changeOption.emit( this.option );
        }
    }
    
    increment(): void {
        if ( this.option ) {
            this.option.quantity++;
            this.changeQuantity.emit( this.option );
        }
    }
    
    decrement(): void {
        if ( this.option ) {
            this.option.quantity--;
            this.changeQuantity.emit( this.option );
        }
    }
    
    getTooltipPosition(): string {
        
        return window.visualViewport && window.visualViewport.width <= 700 ? 
            'left' : 'top';
        
    }
}
